import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

import { getWidthByRank } from './helper';

interface BarValueIndicatorProps {
  rank?: number;
}

export const TotalCount = styled.div`
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.gray700};
  text-align: center;
  ${getFontStyle('midium150_B3')};
`;

export const BarChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-top: 16px;
`;

export const BarChart = styled.div`
  max-width: 360px;
  width: 100%;
  height: 37px;
  position: relative;
  background: ${({ theme }) => theme.colors.gray300};
  border-radius: 4px;
`;

export const BarValueIndicator = styled(BarChart)<BarValueIndicatorProps>`
  position: absolute;
  top: 0;
  left: 0;
  background: ${({ theme }) => theme.colors.greypurple300};
  width: ${({ rank }) => getWidthByRank(rank)}%;
`;

export const BarValueIndicatorZeroCount = styled(BarValueIndicator)`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.3;
  width: 40%;
`;

export const LabelChart = styled.label`
  display: flex;
  align-items: center;
  gap: 0 8px;
  position: absolute;
  top: 8px;
  left: 12px;
  color: #fff;
  z-index: 5;
  ${getFontStyle('bold150_B3')};
`;

export const LabelChartZeroCount = styled(LabelChart)`
  color: ${({ theme }) => theme.colors.greypurple400};
`;

export const LabelChartEmpty = styled(LabelChart)`
  color: ${({ theme }) => theme.colors.gray650};
`;

export const CountChart = styled.div`
  position: absolute;
  top: 8px;
  right: 12px;
  color: ${({ theme }) => theme.colors.greypurple300};
  ${getFontStyle('bold150_B3')};
`;

export const CountChartEmpty = styled(CountChart)`
  color: ${({ theme }) => theme.colors.gray600};
`;

export const EmojiWrapper = styled.div`
  width: 16px;
  height: 17px;
`;
